module.exports = __webpack_public_path__ + "img/1_025.f8700227.jpg";